import React, { useState, useEffect } from "react";
// import MobiileLayout from "./mobile";
import DesktopLayout from "./desktop";

const MainLayout = (props) => {
  // const [width, setWidth] = useState(window.innerWidth);
  // const breakpoint = 768; //apple ipad mini
  // const [userData] = useState(props.userData);
  // const [UserLogout] = useState(props.logout);
  // console.log('ddddd1', props)
  useEffect(() => {
    // window.addEventListener("resize", () => setWidth(window.innerWidth));
  }, []);
  return (  <div>
    {/* { width < breakpoint ? <MobiileLayout userData={userData} /> : <DesktopLayout  userData={userData} /> } */}
    <DesktopLayout userData={props} />  </div>)

}
export default MainLayout;
